import { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { TextField, useMediaQuery, Modal } from "@mui/material";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";

import axios from "axios";
import swal from "sweetalert";
import jwt_decode from "jwt-decode";

import {
  EthereumClient,
  w3mConnectors,
  w3mProvider,
} from "@web3modal/ethereum";
import { Web3Modal } from "@web3modal/html";
import {
  arbitrum,
  mainnet,
  polygon,
  polygonMumbai,
  sepolia,
  base,
} from "@wagmi/core/chains";
import {
  watchAccount,
  signMessage,
  disconnect,
  configureChains,
  createConfig,
} from "@wagmi/core";
import { useTheme, createTheme } from "@mui/material/styles";
import walletConnect from "../nftTokenGatingData/images/wallet-connect.jpg";
import phantomWallet from "../nftTokenGatingData/images/phantom.jpg";

function GrantAccess() {
  const [token, setToken] = useState("");
  const [fileName, setFileName] = useState(null);
  const [link, setLink] = useState(null);
  const [loadingScreen, setLoadingScreen] = useState(false);

  const customTheme = createTheme({
    palette: {
      primary: {
        main: "#FDF5E6",
        dark: "#e9e0d4",
      },
    },
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const projectId = "5ffe7fb860784aa0e9cd478e728ab765";
  const chains = [arbitrum, mainnet, polygon, polygonMumbai, sepolia, base];
  // 2. Configure wagmi client
  const { publicClient } = configureChains(
    [mainnet, polygon, polygonMumbai],
    [w3mProvider({ projectId })]
  );
  const wagmiClient = createConfig({
    autoConnect: true,
    connectors: w3mConnectors({ projectId, chains }),
    publicClient,
  });
  // 3. Create ethereum and modal clients
  const ethereumClient = new EthereumClient(wagmiClient, chains);
  const web3Modal = new Web3Modal(
    {
      projectId,
    },
    ethereumClient
  );
  try {
    watchAccount(async function (account) {
      try {
        let signature;
        await new Promise((resolve) => setTimeout(resolve, 3000));
        if (account.address) {
          var address = account.address;
          var message = await sign(address);
          signature = await signMessage({
            message: `${message}`,
          });
          await disconnect();
          setLoadingScreen(true);
          await axios
            .post(
              `${process.env.REACT_APP_BASE_URL}/request-access?email=${email}&signature=${signature}&account=${address}&token=${token}`,
              {
                headers: {
                  "content-type": "application/json",
                  token: localStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              setLoadingScreen(false);
              const data = response.data;
              const url = response.data.links;
              if (data.status) {
                swal(
                  "Access Granted!",
                  `You have been granted ${data.permission} role to Google drive file!`,
                  "success",
                  {
                    button: "Access File",
                  }
                ).then((value) => {
                  if (value) {
                    window.location.replace(url);
                  }
                });
              } else if (data.hasAccess === false) {
                swal(
                  "Not Enough NFT!",
                  "You do not have enough NFT to access the file. Please buy required NFT first!",
                  "warning",
                  {
                    button: "OK",
                  }
                );
              } else if (data.hasAccess) {
                swal(
                  "Wallet Address already has access",
                  `Your Wallet Address link to email: ${data.email} already has access for ${data.permission} role to the file.`,
                  "warning",
                  {
                    buttons: "OK",
                  }
                );
              } else {
                swal({
                  title: "Something Went Wrong!",
                  icon: "error",
                  button: "OK",
                });
              }
            })
            .catch((err) => {
              setLoadingScreen(false);
              swal({
                title: "Something Went Wrong!",
                icon: "error",
                button: "OK",
              });
            });
        }
      } catch (err) {
        await disconnect();
      }
    });
  } catch (err) {
    console.log("error", err);
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const newToken = urlParams.get("token");
    setToken(newToken);
    const decoded = jwt_decode(newToken);
    setFileName(decoded.fileName);
    setLink(decoded.link);
  }, []);

  const [email, setEmail] = useState("");

  function handleChange(event) {
    const newValue = event.target.value;
    setEmail(newValue);
  }

  async function sign(account) {
    var msg = await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/sign-message?account=${account}`,
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        const data = response.data;
        return data;
      });
    return msg;
  }

  async function WalletConnect() {
    try {
      closeModal();
      await web3Modal.openModal();
    } catch (err) {
      await disconnect();
      // localStorage.clear();
    }
  }

  async function PhantomWalletConnect() {
    closeModal();
    let provider = await getProviderForSolana();
    await provider.connect();
    let publicKey = provider.publicKey.toString();
    var message = await sign(publicKey);
    const encodedMessage = new TextEncoder().encode(message);
    const signedMessage = await provider.signMessage(encodedMessage, "utf8");
    let jsonBody = {
      message: message,
      publicKey: publicKey,
      signature: signedMessage.signature,
    };
    setLoadingScreen(true);
    await axios
      .post(
        `${
          process.env.REACT_APP_BASE_URL
        }/request-access?email=${email}&account=${publicKey}&token=${token}&phantomWallet=${true}`,
        jsonBody,
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        setLoadingScreen(false);
        const data = response.data;
        const url = response.data.links;
        if (data.status) {
          swal(
            "Access Granted!",
            `You have been granted ${data.permission} role to Google drive file!`,
            "success",
            {
              button: "Access File",
            }
          ).then((value) => {
            if (value) {
              window.location.replace(url);
            }
          });
        } else if (data.hasAccess === false) {
          swal(
            "Not Enough NFT!",
            "You do not have enough NFT to access the file. Please buy required NFT first!",
            "warning",
            {
              button: "OK",
            }
          );
        } else if (data.hasAccess) {
          swal(
            "Wallet Address already has access",
            `Your Wallet Address link to email: ${data.email} already has access for ${data.permission} role to the file.`,
            "warning",
            {
              buttons: "OK",
            }
          );
        } else {
          swal({
            title: "Something Went Wrong!",
            icon: "error",
            button: "OK",
          });
        }
      })
      .catch((err) => {
        setLoadingScreen(false);
        swal({
          title: "Something Went Wrong!",
          icon: "error",
          button: "OK",
        });
      });
  }

  const getProviderForSolana = async () => {
    if ("phantom" in window) {
      const provider = window.phantom?.solana;
      if (provider?.isPhantom) {
        return provider;
      }
    } else {
      document.write("Install https://www.phantom.app/");
    }
  };

  async function submitForm(event) {
    try {
      event.preventDefault();
      openModal();
    } catch (err) {}
  }

  return (
    <div>
      {loadingScreen && (
        <div
          style={{
            opacity: "1 !important",
            zIndex: "2",
            textAlign: "center",
            position: "absolute",
            marginLeft: "49%",
            marginTop: "20%",
          }}
        >
          <CircularProgress />
        </div>
      )}

      <div
        style={{ opacity: loadingScreen ? "0.2" : "1" }}
        className="backgroundLayout"
      >
        <Box style={{ width: "28%", marginTop: "10%" }}>
          <Card className="cardLayout">
            <h1
              style={{
                fontWeight: "bold",
                marginTop: "0",
                marginBottom: "3rem",
              }}
            >
              Google Drive Access
            </h1>
            <div
              style={{
                fontWeight: "500",
                fontSize: "90%",
                paddingBottom: "1rem",
              }}
            >
              <Chip
                className="link"
                clickable
                component="a"
                href={link}
                icon={<InsertDriveFileIcon className="icon1" />}
                label={fileName && fileName}
              />
            </div>
            <p style={{ fontWeight: "100", fontSize: "90%" }}>
              Enter your email to request access to the above file.{" "}
            </p>
            <form onSubmit={submitForm}>
              <Box mb={2}>
                <TextField
                  size="small"
                  onChange={(e) => handleChange(e)}
                  type="email"
                  label="Email"
                  value={email}
                  required
                  fullWidth
                />
              </Box>
              <Box mt={4} mb={1}>
                <Button
                  className="custom-color-button"
                  type="submit"
                  variant="contained"
                  fullWidth
                >
                  Request Access
                </Button>
              </Box>
            </form>
            <Modal
              open={isModalOpen}
              onClose={closeModal}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: isMobile ? "90%" : "60%",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  maxWidth: 500,
                  backgroundColor: "white",
                  padding: "3px",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  transform: "translate(-50%, -59%)",
                  top: "50%",
                  left: "50%",
                  position: "absolute",
                  boxShadow: "4px 4px 8px rgba(0, 0, 0, 0.2)",
                  borderRadius: "18px",
                }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={WalletConnect}
                  sx={{
                    height: "11rem",
                    marginBottom: "0.3rem",
                    backgroundColor: "#FDF5E6",
                    color: "black",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    "&:hover": {
                      backgroundColor: customTheme.palette.primary.dark,
                    },
                    fontSize: "1rem",
                  }}
                >
                  <div
                    style={{
                      width: "5.5rem",
                      height: "5.5rem",
                      borderRadius: "50%",
                      overflow: "hidden",
                      marginRight: "1rem",
                      objectFit: "cover",
                      maxWidth: "100%",
                    }}
                  >
                    <img
                      src={walletConnect}
                      alt="Icon"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  Metamask or Wallet Connect
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={PhantomWalletConnect}
                  sx={{
                    height: "11rem",
                    backgroundColor: "#FDF5E6",
                    color: "black",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    "&:hover": {
                      backgroundColor: customTheme.palette.primary.dark,
                    },
                    fontSize: "1rem",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                >
                  <div
                    style={{
                      width: "5.5rem",
                      height: "5.5rem",
                      borderRadius: "50%",
                      overflow: "hidden",
                      marginRight: "1rem",
                      marginLeft: "-8rem",
                    }}
                  >
                    <img
                      src={phantomWallet}
                      alt="Icon"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  Phantom Wallet
                </Button>
              </div>
            </Modal>
          </Card>
        </Box>
      </div>
    </div>
  );
}

export default GrantAccess;
